<template>
    <div>
        <layout>
            <Search slot="header-bar" placeholder="请输入关键字搜索" v-model="search.input" @search="onRefresh">
                <!--<div slot="left-icon">-->
                <!--<button slot="left-icon" @click="unitPanel=true"-->
                <!--style="border: none;background-color: white;border-right: 1px solid #EEEEEE;margin-right: 5px;">-->
                <!--{{unitName}}-->
                <!--</button>-->
                <!--</div>-->
            </Search>
            <PullRefresh v-model="isReFresh" @refresh="onRefresh">
                <List
                        style="height: calc(100vh - 70px);overflow-y:auto;margin-top:-5px;padding: 5px 12px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        loading-text="拼命加载中..."
                        @load="onLoad"
                        :offset="50"
                        :immediate-check="true"
                >
                    <TaskPointItem v-for="item in taskPoints" :key="item.id" :taskPoint="item" @onUpdate="onUpdate"
                                   @onRefresh="onRefresh"/>
                </List>
            </PullRefresh>
        </layout>
        <Icon name="add" size="55px" color="#1988fa" @click="addPoint" class="float-btn-add"/>
        <SelectTreePopup :show="unitPanel" :defaultSelected="search.unitId?{id:search.unitId,name:search.unitName}:{}"
                         :treeData="unitTree"
                         :defaultTitle="unitName" @ok="onUnitOk" @cancel="unitPanel=false"/>
        <SafePointPopup :show="show" type="safePointPopup" @panel="switchPanel" :taskPoint="selected"
                        @onRefresh="onRefresh"/>
    </div>
</template>

<script>
    import {Icon, List, PullRefresh, Search} from "vant"
    import TaskPointItem from "../components/TaskPointItem"
    import SafePointPopup from "../components/SafePointPopup"
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import {mapGetters} from 'vuex'

    export default {
        components: {SafePointPopup, SelectTreePopup, Icon, TaskPointItem, Search, PullRefresh, List},
        props: {},
        data() {
            return {
                show: false,
                unitPanel: false,
                taskPoints: [],
                search: {
                    input: '',
                    unitId: '',
                    unitName: ''
                },
                isReFresh: false,
                loading: false,
                finished: false,
                selected: {}
            }
        },
        computed: {
            ...mapGetters({unitTree: 'global/unitList'}),
            unitName() {
                return this.search.unitName || '选择单位'
            }
        },
        created() {
            this.$initUnit(this.search)
        },
        mounted() {

        },
        methods: {
            onUnitOk(data) {
                this.unitPanel = false
                this.search.unitId = data.id
                this.search.unitName = data.name
                this.onRefresh()
            },
            onUpdate(selected) {
                this.selected = selected
                this.$router.push('/safety/point/update/' + this.selected.id)
            },
            addPoint() {
                this.selected = {unitId: this.search.unitId, unitName: this.search.unitName}
                this.$router.push('/safety/point/add')
            },
            switchPanel(type, data) {
                switch (type) {
                    case "safePointPopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
            onRefresh() {
                this.isReFresh = true;
                this.taskPoints = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.safety.position.list({
                    name: this.search.input,
                    unitId: this.$default.unitOrOrgan.id,
                    size: 20,
                    page: this.taskPoints.length / 20 + 1
                }).then(res => {
                    if (res) {
                        this.taskPoints.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.taskPoints.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style scoped>
    /*.float-btn-add {*/
    /*position: fixed;*/
    /*bottom: 45px;*/
    /*right: 20px;*/
    /*z-index: 999;*/
    /*padding-top: 2px;*/
    /*!*box-shadow: 3px 3px 5px rgb(226, 225, 225);*!*/
    /*}*/

    .float-btn-add {
        position: fixed;
        bottom: 28px;
        right: 20px;
        z-index: 999;
        padding-top: 2px;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }

</style>